import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const productReExportApi = createApi({
  reducerPath: "productReExportApi",
  baseQuery,
  tagTypes: ["ReExport"],
  endpoints: (builder) => ({
    getProductReExportById: builder.query({
      query: ({id}) => `/export/product/reExport/${id}`,
      transformResponse: (response) => response?.data ?? [],
      providesTags: ["ReExport"],
    }),

    createReExport: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/reExport/${id}`,
        method: "PUT",
        body: {productReExport:data},
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["ReExport"],
    }),
  }),
});

export const {
  useCreateReExportMutation,
  useLazyGetProductReExportByIdQuery,
} = productReExportApi;
